<!-- src/views/common/AccessRequired.vue -->
<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div class="card max-w-md w-full text-center">
      <div class="mx-auto mb-4 w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
        <svg class="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </div>
      <h1 class="text-xl font-semibold text-gray-900 m-0">{{ heading }}</h1>
      <p class="text-sm text-gray-600 mt-2 mb-0">
        Ask your viaPhoton contact to grant access for
        <span class="font-medium text-gray-900">{{ email }}</span
        >. Once that's done, sign out and back in.
      </p>
      <div class="mt-6">
        <router-link :to="{ name: 'Logout' }" class="btn-secondary inline-block">Sign out</router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import { useAccess } from '@/composables/useAccess';
  import { useAccessStore } from '@/store/accessStore';
  import { useAuthStore } from '@/store/authStore';

  const accessStore = useAccessStore();
  const authStore = useAuthStore();
  const { hasAnyAccess } = useAccess();

  // Three reasons to land here: no permissions at all, vendor-scoped
  // permissions with no vendor mapping, or access this build can't route to
  // (Home found no landing page). All get "ask your contact" copy below; the
  // heading just shouldn't claim the wrong one.
  const heading = computed(() => {
    if ((accessStore.me?.permissions ?? []).length === 0) return "Your account hasn't been set up yet";
    return hasAnyAccess.value ? "Your account doesn't have access to any pages yet" : "Your account isn't linked to any vendor yet";
  });

  const email = computed(() => accessStore.me?.email || authStore.user?.email || 'your account');
</script>
